import React, { useState } from 'react';
import { getConfig, serverUrl } from '../../../../serverUrl';
import { toast } from 'react-toastify';

const paymentMethods = [
    { value: '', label: 'Select method' },
    { value: 'mpesa', label: 'M-Pesa' },
    { value: 'bank_transfer', label: 'Bank Transfer' },
    { value: 'cash', label: 'Cash' },
    { value: 'cheque', label: 'Cheque' },
];

const RejectTransactionModal = ({ tenant, onClose, onSave }) => {
    const [editedData, setEditedData] = useState({
        paid_amount: tenant?.paid_amount || '',
        transaction_id: tenant?.transaction_id || '',
        payment_method: tenant?.payment_method || '',
        id: tenant?.id || '',
        ctob_id: tenant?.ctob_id || '', // Add ctob_id to state
    });
    const [confirmation, setConfirmation] = useState(false);
    const [noTransactionIdConfirm, setNoTransactionIdConfirm] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const config = getConfig();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('🔍 1. Form submitted, confirmation status:', confirmation);
        console.log('🔍 1a. Tenant ID from prop:', tenant?.id);
        console.log('🔍 1b. EditedData ID:', editedData.id);
        console.log('🔍 1c. CTOB ID:', editedData.ctob_id);
        
        if (!confirmation) {
            toast.warning('Please confirm you want to reject this payment');
            return;
        }

        // Check if transaction_id is empty and show confirmation
        if (!editedData.transaction_id && !noTransactionIdConfirm) {
            toast.warning('Transaction ID is empty. Please confirm to proceed without transaction ID.');
            return;
        }

        setIsSubmitting(true);

        try {
            console.log('🔍 2. Edited data before request:', editedData);
            console.log('🔍 3. Config being used:', config);
            console.log('🔍 4. Full tenant object:', tenant);

            let requestUrl;
            
            // ✅ NEW LOGIC: Use ctob_id if approval_id is null/empty
            if (!editedData.id && editedData.ctob_id) {
                // Case: No approval_id but has ctob_id - reject CTOB transaction
                console.log('🔍 5a. Using CTOB rejection endpoint');
                requestUrl = `/landlord/reject-payment-approvals?ctob_id=${editedData.ctob_id}`;
            } else if (editedData.id) {
                // Case: Has approval_id - reject PaymentApproval
                console.log('🔍 5b. Using PaymentApproval rejection endpoint');
                requestUrl = `/landlord/reject-payment-approvals?approval_id=${editedData.id}`;
            } else {
                // Case: No valid ID
                console.error('❌ MISSING BOTH APPROVAL_ID AND CTOB_ID');
                toast.error('Missing transaction ID. Cannot reject payment.');
                setIsSubmitting(false);
                return;
            }

            console.log('🔍 6. Full request URL:', requestUrl);
            console.log('🔍 7. Base server URL should be:', serverUrl?.defaults?.baseURL);
            console.log('🔍 8. Config headers:', config?.headers);

            console.log('🔍 9. Making GET request now...');
            const response = await serverUrl.get(requestUrl, config);

            console.log('✅ 10. SUCCESS - Response received!');
            console.log('🔍 11. Response status:', response.status);
            console.log('🔍 12. Response data:', response.data);

            toast.success('Payment rejected successfully');
            
            console.log('🔍 13. Closing modal and reloading page');
            onClose();
            window.location.reload();
            
        } catch (error) {
            console.error('❌ 14. FAILED - Full error object:', error);
            
            if (error.response) {
                console.error('❌ ERROR RESPONSE DETAILS:');
                console.error('   - Status:', error.response.status);
                console.error('   - Data:', error.response.data);
                
                const serverMessage = error.response.data?.message || error.response.data?.error || error.response.data || 'Unknown server error';
                console.error('❌ Server error message:', serverMessage);
                
                if (error.response.status === 404) {
                    toast.error('Endpoint not found (404). Check the API URL.');
                } else if (error.response.status === 401) {
                    toast.error('Authentication failed (401). Please check your credentials.');
                } else if (error.response.status === 403) {
                    toast.error('Permission denied (403). You may not have access to this action.');
                } else {
                    toast.error(`Server error (${error.response.status}): ${serverMessage}`);
                }
                
            } else if (error.request) {
                console.error('❌ NO RESPONSE RECEIVED:');
                console.error('   - Request object:', error.request);
                toast.error('No response from server. Please check your connection and try again.');
            } else {
                console.error('❌ REQUEST SETUP ERROR:');
                console.error('   - Message:', error.message);
                toast.error('Request setup failed: ' + error.message);
            }
            
        } finally {
            console.log('🔍 15. Final cleanup - setting isSubmitting to false');
            setIsSubmitting(false);
        }
    };

    // Check if transaction_id is empty
    const isTransactionIdEmpty = !editedData.transaction_id;

    return (
        <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 p-4">
            <div className="bg-white shadow-lg rounded-lg w-full max-w-md">
                <div className="p-6">
                    <h2 className="mb-4 font-semibold text-xl">Reject Payment</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <p className="block mb-2 font-bold text-gray-950 text-md" />
                            Amount Paid
                            <input
                                type="number"
                                name="paid_amount"
                                value={editedData.paid_amount}
                                onChange={handleChange}
                                className="mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                                required
                                min="0"
                                step="0.01"
                                disabled={isSubmitting}
                            />
                        </div>

                        <div className="mb-4">
                            <p className="block mb-2 font-bold text-gray-950 text-md" />
                            Transaction ID
                            <input
                                type="text"
                                name="transaction_id"
                                value={editedData.transaction_id}
                                onChange={handleChange}
                                className="mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                                placeholder="Optional - leave empty if no transaction ID"
                                disabled={isSubmitting}
                            />
                            {isTransactionIdEmpty && (
                                <p className="text-sm text-yellow-600 mt-1">
                                    Transaction ID is empty. You can proceed without it.
                                </p>
                            )}
                        </div>

                        {/* Optional: Show which ID will be used for rejection */}
                        <div className="mb-4 p-3 bg-gray-100 rounded-md">
                            <p className="text-sm font-medium">Rejection Details:</p>
                            {editedData.id && (
                                <p className="text-sm text-green-600">
                                    Will reject Payment Approval ID: {editedData.id}
                                </p>
                            )}
                            {!editedData.id && editedData.ctob_id && (
                                <p className="text-sm text-blue-600">
                                    Will reject CTOB Transaction ID: {editedData.ctob_id}
                                </p>
                            )}
                            {!editedData.id && !editedData.ctob_id && (
                                <p className="text-sm text-red-600">
                                    No valid transaction ID found
                                </p>
                            )}
                        </div>

                        {/* Confirmation for empty transaction ID */}
                        {isTransactionIdEmpty && (
                            <div className="mb-4">
                                <p className="flex items-center">
                                    <input
                                        type="checkbox"
                                        checked={noTransactionIdConfirm}
                                        onChange={() => setNoTransactionIdConfirm(!noTransactionIdConfirm)}
                                        className="mr-2"
                                        disabled={isSubmitting}
                                    />
                                    <span className="font-medium text-yellow-600">
                                        I confirm I want to proceed without a Transaction ID
                                    </span>
                                </p>
                            </div>
                        )}

                        {/* Main rejection confirmation */}
                        <div className="mb-4">
                            <p className="flex items-center">
                                <input
                                    type="checkbox"
                                    checked={confirmation}
                                    onChange={() => setConfirmation(!confirmation)}
                                    className="mr-2"
                                    disabled={isSubmitting}
                                />
                                <span className="font-medium text-red-600">
                                    I confirm I want to reject this payment
                                </span>
                            </p>
                        </div>

                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                type="button"
                                onClick={onClose}
                                disabled={isSubmitting}
                                className="disabled:opacity-50 px-4 py-2 text-gray-600 hover:text-gray-800 transition"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={isSubmitting || !confirmation || (isTransactionIdEmpty && !noTransactionIdConfirm)}
                                className="bg-red-500 hover:bg-red-600 disabled:opacity-50 px-4 py-2 rounded-md text-white transition disabled:cursor-not-allowed"
                            >
                                {isSubmitting ? 'Rejecting...' : 'Reject Payment'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default RejectTransactionModal;